// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3JU6z","explanation":"styles_explanation__1rt-v","retry":"styles_retry__TG-QV"};